<template>
  <div class="floors" v-show="isShow">
    <!--TITLE S-->
    <div class="floors-title">
      <h2>{{ title }}</h2>
      <div class="title-items">
        <ul>
          <li
            v-for="(item, index) in applyList"
            :key="index"
            :class="index===currIndex?'active':''"
            @click="changeIndex(index)"
            :shows="!applyDataList[index]"
            v-show="applyDataList[index]&& applyDataList[index].length && applyDataList[index].length>=5"
          >{{ item.cnName }}</li>
        </ul>
      </div>
    </div>
    <!--TITLE E-->
    <div class="floors-content">
      <!--CONTENT S-->
      <div class="content">
        <div
          v-for="(info, index) in applyDataList"
          :key="index"
          v-show="index === currIndex">
          <loading v-if="!applyDataList"></loading>
          <a
            v-for="(item, itemIndex) in info"

            :key="itemIndex"
            :class="overPreCurrent == itemIndex ? 'prea' : ''"
            @mouseenter="overSetCurrent(itemIndex)"
            @mouseleave="overSetCurrent(-1)"
          >
            <span class="coursename" @click="winTo(item.churl)" :title="item.title" v-html="item.title"></span>
            <span class="place" @click="winTo(item.churl)" :title="item.content"><i></i><span v-html="item.content"></span></span>
            <span class="btn"><button @click="winTo('http://liuxue.xdf.cn/looyu/looyuIp-nxdfguanwang.html',1)">在线咨询</button></span>
          </a>
        </div>
      </div>
      <!--CONTENT E-->
      <!--NEWS S-->
      <zixun :title="newsTitle" :typeids='typeId' cow="3"></zixun>
      <!--NEWS E-->
    </div>
  </div>
</template>

<script>
import AdModel from '@/common-components/AdModel'
import Loading from '@/common-components/Loading'
import { mapState } from 'vuex'
import Zixun from './Zixun'
import {getApplyData} from 'js/youxue.js'
export default {
  name: 'FloorFull',
  components: {
    AdModel,
    Loading,
    Zixun
  },
  props: ['title', 'adCode', 'applyList', 'newsTitle', 'typeId'],
  data () {
    return {
      currentItem: String,
      currIndex: -1,
      applyDataList: [],
      overPreCurrent: -1
    }
  },
  mounted () {
    let _this = this
    let initData = []
    // 出国申请
    let initApplyData = []
    this.formaterRequest(0, this.getApplyOnce, function(res, i){
        if (res.length >= 5) {
          initApplyData[i] = res
        } else {
          initApplyData[i] = []
        }
        // console.log('../',res)
        if(i == _this.applyList.length - 1){
          _this.applyDataList = initApplyData
        }
    },_this.applyList.length)
    // for (let i = 0; i < this.applyList.length; i++) {
    //   getApplyData(this.applyList[i].enName).then((res) => {
    //     _this.applyDataList.push(i > 5 ? res.slice(0,3) : res)
    //   }).catch((err) => {
    //     console.log(err)
    //   })
    // }
  },
  computed: {
    isShow(){
      let r = [],_this = this, defaulti = -1
      this.applyDataList.forEach((item,index) => {
        if(item.length && item.length >= 5 && defaulti == -1){
          defaulti = index
        }
      })
      _this.currIndex = defaulti
      return defaulti == -1 ? 0 : 1
    },
    isNavConLg5(){
      return 1
    },
    ...mapState(['soukecityId'])
  },
  watch: {
    list (newVal) {
      this.currentItem = this.applyList[0] ? this.applyList[0].cnName : ''
    }
  },
  methods: {
    getApplyOnce (i) {
      return getApplyData(this.applyList[i].enName)
    },
    formaterRequest (i, fn ,suc, len) {
      if(i>=len) return false
      fn(i).then(res => {
        suc(res, i)
        i++
        this.formaterRequest(i,fn,suc,len)
      }).catch(rej => {
        i++
        this.formaterRequest(i,fn,suc,len)
      })
    },
    winTo (url,f) {
        return f ? window.open(url) : (window.location.href = url)
    },
    navIsShowClass(index){

    },
    overSetCurrent(index) {
      this.overPreCurrent = index > 0 ? index - 1 : -1
    },
    changeIndex (index) {
      this.currIndex = index
    }
  }
}
</script>

<style lang="stylus" scoped>
@import '~styles/varibles.styl'
@import '~styles/mixins.styl'
.articleContentTitle
  flex: 2
  font-size: 15px
  color: #4a4a4a
  line-height: 35px
  em
    width: 4px
    height: 16px
    top: 3px
    position: relative
    display: inline-block
    margin-right: 10px
    background-color: $articleIcon
  i
    position: $abs
.floors
  width: 1200px
  height: 350px
  margin: 18px auto
  display: flex
  flex-direction: column
  .floors-title
    height: 38px
    line-height: 38px
    padding-left: 6px
    border-bottom: 2px solid #98dfd2
    display: flex
    h2
      font-size: 20px
      flex: 1
    .title-items
      flex: 4
      ul
        li
          float: $fl
          color: #606060
          font-size: 14px
          padding: 0 20px
          cursor: pointer
        .active
          background: #fff
          color: $themeColor
          height: 40px
          position: relative
          top: -2px
          border-left: 1px solid #a5e1d6
          border-right: 1px solid #a5e1d6
          border-top: 2px solid $themeColor
  .floors-content
    flex: 1
    display: flex
    overflow hidden
    .content
      flex: 10
      padding-right: 10px
      a
        display: flex
        cursor: pointer
        height: 60px
        line-height: 60px
        border: 1px solid transparent
        border-bottom-color: #eee
        color: #8e8e8e
        overflow: hidden
        &:hover
          background: #f4fcfc
          border-color: #cbe9e9
          overflow: hidden
          .coursename
            color #00b388
          button
            background: $themeColor
            color: #fff
            border-color $themeColor
        span
          flex: 3
          text-align: center
          button
            flex: 1
            border: 1px solid #d0eae8
            border-radius: 2px
            background: #f4fcfc
            color: $themeColor
            padding: 4px 18px
            font-size: 16px
            margin-top: 12px
            cursor pointer
        .coursename
          font-size: 13px
          color: #333
          text-align: left
          padding: 0 10px
          width: 226.19px
          display: block
        .place
          padding: 0 16px
          position: relative
          text-align: left
          width: 226.19px
          display: block
          i
            width: 14px
            height: 14px
            left: 0
            top: 50%
            margin-top: -7px
            display: block
            position: absolute
            // background: url(http://images.xdf.cn/school/middleschool/static/images/sprite.png) no-repeat -178px -63px
        .time
          flex: 2
          padding: 0 16px
          position: relative
          text-align: left
          width: 150.8px
          display: block
          i
            width: 12px
            height: 14px
            left: 1px
            top: 50%
            margin-top: -7px
            display: block
            position: absolute
            background: url(http://images.xdf.cn/school/middleschool/static/images/sprite.png) no-repeat -216px -63px
        .price
          flex: 1
          color: #ff7011
          font-size: 18px
          width: 75.4px
          display: block
      .btn
        width: 150.8px
        display: block
        flex: 2
        text-align right
        padding-right 9px
      .prea{
        border-color: transparent
      }
    .article
      flex: 3
      display: flex
      padding: 11px 0
      flex-direction: column
      .AD-articleContent
        flex: 2
        display: flex
        padding-left: 14px
        flex-direction: column
        ul
          flex: 10
          display: flex
          flex-direction: column
          li
            flex: 1
            width: 226px
            height: 29px
            line-height: 29px
            a
              width: 90%
              color: #666
              ellipsis()
              &:hover
                color: $themeColor
          .articleNumber
            width: 14px
            height: 14px
            border-radius: 2px
            display: inline-block
            text-align: center
            line-height: 14px
            color: #fff
            margin-right: 5px
            background-color: #cacaca
            font-size: 12px
            float: left
            position: relative
            top: 6px
          .hotNews
            background-color: #ff7011
      .articleAd
        flex: 1
</style>



// WEBPACK FOOTER //
// src/pages/gobroad/components/mainfloor/Apply.vue